import * as React from "react";
import TextField from "@mui/material/TextField";

import SearchIcon from "@mui/icons-material/Search";

class AuthoringFilter extends React.Component<IAuthoringFilterProps, ComponentState> {
  public render() {
    return (
      <React.Fragment>
        <TextField
          id="authoring-search-text"
          variant="outlined"
          size="small"
          value={this.props.textToSearch}
          placeholder={this.props.searchTextPlaceholder || "Search title, key words or content"}
          InputProps={{
            startAdornment: <SearchIcon className="search-icon" />
          }}
          onChange={this.props.onUpdateTextToSearch}
          onKeyUp={this.onKeyUp}
          className="text-to-search"
        />
        {this.props.additionalFilters}
      </React.Fragment>
    );
  }

  private onKeyUp = (key) => {
    if (key.keyCode === 13)
      this.props.onChangeTextToSearch();
  }
}
  

interface IAuthoringFilterProps {
  textToSearch: string;
  additionalFilters?: JSX.Element;
  searchTextPlaceholder?: string;
  onChangeTextToSearch: () => void;
  onUpdateTextToSearch: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

interface ComponentState {}

export default AuthoringFilter;